import * as React from 'react';
const SvgPerson = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 14 16" fill="none" {...props}>
        <path
            d="M13.719 14.293a1 1 0 01-.712 1.695 1.002 1.002 0 01-.705-.281C11.175 14.582 9.426 14 7 14c-2.426 0-4.175.582-5.302 1.707A1.002 1.002 0 010 14.997a1 1 0 01.281-.704C1.825 12.75 4.083 12 7 12c2.917 0 5.174.751 6.719 2.293zM7 10.8c-2.635 0-4.509-2.692-4.509-5.83C2.492 2 4.091 0 7.001 0s4.507 2 4.507 4.97c0 3.138-1.873 5.83-4.507 5.83zm0-2c1.31 0 2.503-1.596 2.503-3.83C9.504 2.961 8.663 2 7.001 2c-1.663 0-2.505.962-2.505 2.97C4.496 7.203 5.692 8.8 7 8.8z"
            fill="currentColor"
        />
    </svg>
);
export default SvgPerson;
